// Composite — EvaluationStepCard constants
export const EVALUATION_STEP_CARD_ICON = {
    DUPLICATE: 'copy-06',
    REMOVE: 'trash-01',
    REMOVE_ROW: 'x-close',
};

export const EVALUATION_STEP_CARD_COLUMN = {
    SKILL: 'skill',
    QUESTION: 'question',
    FORMAT: 'format',
    ACTIONS: 'actions',
};

// Column geometry from the approved design: fixed skill / format / action columns, fluid question.
export const EVALUATION_STEP_CARD_COLUMN_WIDTH = {
    SKILL: 200,
    FORMAT: 160,
    ACTIONS: 44,
};

export const EVALUATION_STEP_CARD_STEP_SELECT_WIDTH = 200;
export const EVALUATION_STEP_CARD_SKILL_SELECT_WIDTH = 200;

// Class hooks kept from the pre-composite markup; acceptance tests and the templates modal target them.
export const EVALUATION_STEP_CARD_LEGACY_CLASS = {
    CARD: 'evaluation_criteria_item',
    HEADER: 'evaluations_action_row',
    STEP_SELECT: 'step-select',
    ACTIONS: 'action_links',
    TABLE: 'evaluation-step-table',
    FOOTER: 'add_skills_row',
    SKILL_SELECT: 'skill-select',
    RATING_SELECT: 'rating-input',
};
